import { request } from "react-rb/request"

/**
 * List the available kinds of plugins.
 *
 * @return {object[]} The kinds of plugins
 */
export async function listPluginKinds() {
  const response = await request("/plugins/kinds.json", {
    method: "GET"
  })
  if (!response.ok) throw response
  return response.data
}

/**
 * List the available plugin environments.
 *
 * @return {object[]} The plugin environments
 */
export async function listPluginEnvironments() {
  const response = await request("/plugins/environments.json", {
    method: "GET"
  })
  if (!response.ok) throw response
  return response.data
}

/**
 * Create a new plugin
 *
 * @return {object} The plugin
 */
export async function createPlugin({ appId, label, kind }) {
  const response = await request(`/apps/${appId}/plugins`, {
    method: "POST",
    data: { label, kind }
  })
  if (!response.ok) throw response
  return response.data.plugin
}

/**
 * Update a new plugin
 *
 * @return {object} The plugin
 */
export async function updatePlugin(pluginData) {
  const {
    id,
    label,
    description,
    icon_url,
    sort_order,
    request_url,
    settings,
    scopes,
    identifier,
    appId,
    kind,
    dynamic,
    related_plugin_id,
    context_field_names,
    context_sample_values
  } = pluginData

  const response = await request(`/apps/${appId}/plugins/${id}`, {
    method: "PUT",
    data: {
      label,
      description,
      icon_url,
      sort_order,
      request_url,
      settings,
      scopes,
      identifier,
      kind,
      dynamic,
      related_plugin_id,
      context_field_names,
      context_sample_values
    }
  })
  if (!response.ok) throw response
  return response.data.plugin
}

/**
 * Delete a plugin
 */
export async function deletePlugin(pluginData) {
  const { id } = pluginData

  const response = await request(`/editor/plugin_elements/${id}`, {
    method: "DELETE"
  })
  if (!response.ok) throw response

  return response.data
}

/**
 * List the available plugins.
 *
 * @param {object} [queryParams={}] - The query parameters for the request
 * @return {object[]} The list of plugins
 */
export async function listPlugins(queryParams = {}) {
  const params = new URLSearchParams(queryParams)
  const url = `/plugins${params.toString() ? `?${params}` : ""}`

  const response = await request(url, { method: "GET" })
  if (!response.ok) throw response

  return response.data
}
